"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const domain_1 = require("@oolio-group/domain");
/**
 * Initializes order, sets status to CREATED
 * Creates an empty list of order items and sets price to 0
 * Optionally assigns orderType and table
 * @param event of type InitiateOrderEvent
 * @param prevState
 */
function default_1(event, prevState = {}) {
    let orderStatus = domain_1.OrderStatus.CREATED;
    if (event.status && domain_1.VALID_INITIAL_ORDER_STATUS.includes(event.status)) {
        orderStatus = event.status;
    }
    const order = {
        ...prevState,
        orderItems: [],
        createdAt: event.timestamp,
        createdBy: { id: event.triggeredBy, name: event.triggeredUserName },
        createdByDevice: { id: event.deviceId, name: event.triggeredDeviceName },
        id: event.orderId,
        table: null,
        orderNumber: event.orderNumber,
        organization: { id: event.organizationId },
        status: orderStatus,
        venue: { id: event.venueId },
        store: { id: event.storeId },
        totalPrice: 0,
        totalPaymentAmount: 0,
        totalTax: 0,
        subTotal: 0,
        integrationInfo: event.integrationInfo,
        discountAmount: 0,
        discounts: [],
        payments: [],
        ...(event.isTraining && {
            isTraining: event.isTraining,
        }),
    };
    if (event.orderTypeId) {
        order.orderType = { id: event.orderTypeId };
    }
    if (Number.isInteger(event.tokenNumber)) {
        order.tokenNumber = event.tokenNumber;
    }
    if (event.salesChannelId) {
        order.salesChannel = { id: event.salesChannelId };
    }
    if (event.tableId || event.tableName) {
        order.table = { id: event.tableId, name: event.tableName };
        order.tables = [{ id: event.tableId, name: event.tableName }];
    }
    if (event.source) {
        order.source = event.source;
    }
    return order;
}
exports.default = default_1;
//# sourceMappingURL=initiateOrder.js.map